import { useTranslation } from '@mint-lib/i18n';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogRoot,
  DialogTitle,
} from '@mint-lib/tw-components';

import type { UserInfo } from '../../api/types.js';

export const TakeOverReleaseDialog = ({
  userRequestedBy,
  onClose,
  onSubmit,
  isSubmitting,
}: {
  userRequestedBy: UserInfo;
  onClose: () => void;
  onSubmit: () => void;
  isSubmitting: boolean;
}) => {
  const { t } = useTranslation('@myn/import-hub');

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      onClose();
    }
  };

  return (
    <Dialog open onOpenChange={handleOpenChange}>
      <DialogPortal>
        <DialogOverlay />
        <DialogRoot size="s">
          <DialogHeader>
            <DialogTitle>
              {t('Do you want to let another user edit this wizard?')}
            </DialogTitle>
          </DialogHeader>
          <DialogContent>
            <DialogDescription>
              {t(
                '{{userEmail}} wants to edit this wizard. Accept to transfer control, or decline to keep editing.',
                {
                  userEmail: userRequestedBy.email,
                },
              )}
            </DialogDescription>
          </DialogContent>
          <DialogFooter>
            <Button
              data-dd-action-name="Take over release: decline"
              size="large"
              variant="text"
              onClick={onClose}
            >
              {t('No, decline control')}
            </Button>
            <Button
              data-dd-action-name="Take over release: give control"
              size="large"
              onClick={onSubmit}
              disabled={isSubmitting}
            >
              {t('Yes, give control')}
            </Button>
          </DialogFooter>
        </DialogRoot>
      </DialogPortal>
    </Dialog>
  );
};
